import {
  CircularProgress, HStack, Input as ChakraInput, InputGroup,
  InputRightElement, Text
} from "@chakra-ui/react";
import { useCallback, useMemo, useState } from "react";

const SendCodeInput = ({
  w,
  onClick,
  onChange,
  disabled,
  width,
  label,
  timer,
  loading,
  includeCallDial,
  ...props
}) => {
  const [delivery, setDelivery] = useState("sms");

  const deliveryText = useMemo(() => {
    if(delivery === "call") return "Call";
    return "Send Code";
  }, [delivery])

  const deliveringText = useMemo(() => {
    if(delivery === "sms" && (!timer || timer === '00:00')) return "Request dial in";
    if(delivery === "call" && (timer && timer !== '00:00')) return "Dialing...";
    return "Switch to SMS";
  }, [delivery, timer])

  const toggleDelivery = useCallback(() => {
    const newDelivery = delivery === "sms" ? "call" : "sms"
    setDelivery(newDelivery);
    return newDelivery;
  }, [delivery])

  return (
    <>
    <InputGroup>
      <ChakraInput
        w={w}
        width={width}
        onChange={onChange}
        borderRadius="16px"
        errorBorderColor="red.300"
        minH="56px"
        bg="#EFF0F7"
        required={true}
        border="1px solid transparent"
        variant="filled"
        _focus={{
          borderColor: "#06C344",
          boxShadow: "0 0 0 3px #06C3448f",
        }}
        {...props}
      />
      <InputRightElement
        h="100%"
        maxWidth="110px"
        width="100%"
        children={
          loading ? <CircularProgress size="16px" isIndeterminate color="green.300" /> : <BtnComp disabled={disabled} onClick={(e) => {
            onClick(e, delivery)
          }} deliveryText={disabled && timer ? timer : deliveryText} timer={timer} />
        }
      />
    </InputGroup>
    {includeCallDial ? <HStack alignItems="center" mt="4px">
      {disabled && timer ? null : <Text>Prefer {delivery === "sms" ? "voice call" : "sms text"}? </Text>}
      <BtnComp disabled={disabled} onClick={(e) => {
      const newDelivery = toggleDelivery();
      onClick(e, newDelivery)
    }} deliveryText={deliveringText} timer={null} /></HStack> : null}
    </>
  );
};

export default SendCodeInput;

const BtnComp = ({disabled, onClick, timer, deliveryText}) => {
  return (
    <button
      style={{
        color: disabled ? "#000" : "#03A438",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      disabled={disabled}
      onClick={onClick}>
      {disabled && timer ? timer : deliveryText}
    </button>
  )
}